import Meta from 'tennders-stracture/layouts/views/header/Meta'
import { MetaType } from 'tennders-common/types/MetaType'

const GeneralLayoutMeta = (props: { meta: MetaType }) => <Meta {...props} />

GeneralLayoutMeta.displayName = 'GeneralLayoutMeta'

export default GeneralLayoutMeta
